import { ComponentPropsWithoutRef } from "react"
import { cva, RecipeVariantProps } from "styled-system/css"
import { styled } from "styled-system/jsx"
import { SystemStyleObject } from "styled-system/types"

const inputStyle = cva({
  base: {
    height: "45px",
    minWidth: "120px",
    alignSelf: "stretch",
    border: "none",
    borderRadius: "8px",
    background: "white",
    boxShadow: "0px 1px 3px 1px #00000026",
    transition: "background 280ms",

    "&:focus-within": {
      background: "white",
    },

    "&:not(:focus-within):is(:hover, :active)": {
      background: "#E6EBFF",
    },

    "&:not(:focus)::placeholder": {
      color: "#0008",
    },

    "&:focus": {
      outline: "none",
    },

    "&:focus::placeholder": {
      color: "#8596EE",
    },
  },
  defaultVariants: {},
})

export type InputVariants = RecipeVariantProps<typeof inputStyle>
export const Input = styled("input", inputStyle)

export type InputProps = {
  css: SystemStyleObject
} & InputVariants &
  ComponentPropsWithoutRef<"input">
